/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

export const selectHelper = (selected, data, action, key) => {
  let res = data.filter((item) => {return item.uid === selected})[0]

  if (selected === null || !res) {
    res = null
  }

  action(key, res)
}

export const selectHelperMulti = (selections, data, action, key) => {
  let res = data.filter((item) => {
    return selections.indexOf(item.uid) !== -1
  })

  if (selections === null || selections.length === 0 || !res) {
    res = []
  }

  action(key, res)
}



// WEBPACK FOOTER //
// ./src/generic/form/selectHelper.js